export const getForm = state => state.form;
export const getApplication = state => state.application;

export default {};
